import { css } from '@emotion/react';

export const baseStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  padding: var(--spacing-4);
  border-radius: var(--spacing-4);
  border: 1px solid var(--border-primary);
  background-color: var(--surface-page);
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  color: var(--text-primary);

  &:hover {
    border-color: var(--border-disabled);
  }
`;

export const checkedStyles = css`
  background-color: var(--surface-success);
  border-color: var(--border-action);
`;

export const checkboxStyles = css`
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-primary);
  border-radius: var(--spacing-2);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-page);
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--border-disabled);
  }
`;

export const checkboxCheckedStyles = css`
  border-color: var(--border-action);
  background-color: var(--surface-page);
`;
